import './App.css';
import Allroutes from './components/Allroutes';


function App() {
  return (
    <div className='App'>
      <Allroutes />
  
      <h2>coschedule</h2>
    </div>
  );
}

export default App;
